import gql from 'graphql-tag'

import { LeadFieldsFragment } from './lead'

export const LEADS_FOR_PARENT_QUERY = gql`
  query LeadsForParent {
    leads: leadsForParent {
      ...LeadFields
    }
  }

  ${LeadFieldsFragment}
`
